import './TRViwerTechnicalAnalisys.css';
import React, {useState, useEffect} from 'react';

const TRViwerTechnicalAnalisys = ({ symbol }) => {      
    // const url = `https://www.tradingview.com/widgetembed/?symbol=BINANCE%3A${symbol}&interval=D&hide_side_toolbar=0&allow_symbol_change=0&save_image=0&studies=ROC%40tv-basicstudies%5Cu001fStochasticRSI%40tv-basicstudies%5Cu001fMASimple%40tv-basicstudies&theme=dark&style=1&timezone=exchange&withdateranges=1`;
    const url = `https://www.tradingview.com/widgetembed/?symbol=${symbol}&interval=D&hide_side_toolbar=0&allow_symbol_change=0&save_image=0&studies=ROC%40tv-basicstudies%5Cu001fStochasticRSI%40tv-basicstudies%5Cu001fMASimple%40tv-basicstudies&theme=dark&style=1&timezone=exchange&withdateranges=1`;
                               
    const [spin, setSpin] = useState(true);
    
    useEffect(() => {
        // Simulating a delay with setTimeout to mimic asynchronous loading
        const timer = setTimeout(() => {
            setSpin(false);
        }, 2000); // Adjust delay time as needed or remove this for actual use with data loading

        return () => clearTimeout(timer); // Cleanup function to clear timeout
    }, []);

    return (
        <>
            <div className={spin?'shimmer_trv':''} style={{width:'745px', height:'504px', marginTop:'30px'}}>                
                {!spin && (
                    
                        <iframe
                            title={`TradingView Chart for ${symbol}`}
                            src={url}
                            style={{ width: '100%', height: '500px', border: 'none' }}
                        />
                    
                )}
            </div>
        </>
    );
};

export default TRViwerTechnicalAnalisys;